export const GET_PURCHASERS_SUCCESS = 'GET_PURCHASERS_SUCCESS';
export const GET_PURCHASERS_FAIL = 'GET_PURCHASERS_FAIL';

export const GET_ALL_AGREEMENTS_SUCCESS = 'GET_ALL_AGREEMENTS_SUCCESS';
export const GET_ALL_AGREEMENTS_FAIL = 'GET_ALL_AGREEMENTS_FAIL';

export const CONVERT_LEAD_SUCCESS = 'CONVERT_LEAD_SUCCESS';
export const CONVERT_LEAD_FAIL = 'CONVERT_LEAD_FAIL';

export const GET_PURCHASER_BY_ID_SUCCESS = 'GET_PURCHASER_BY_ID_SUCCESS';
export const GET_PURCHASER_BY_ID_FAIL = 'GET_PURCHASER_BY_ID_FAIL';

export const GET_AUDIT_TRAIL_SUCCESS = 'GET_AUDIT_TRAIL_SUCCESS';
export const GET_AUDIT_TRAIL_FAIL = 'GET_AUDIT_TRAIL_FAIL';

export const GET_COOLING_SUCCESS = 'GET_COOLING_SUCCESS';
export const GET_COOLING_FAIL = 'GET_COOLING_FAIL';

export const GET_DOC_TARGET_SUCCESS = 'GET_DOC_TARGET_SUCCESS';
export const GET_DOC_TARGET_FAIL = 'GET_DOC_TARGET_FAIL';

export const SET_LOADING_SUCCESS = 'SET_LOADING_SUCCESS';
export const SET_LOADING_FAIL = 'SET_LOADING_FAIL';
